export interface BlogPost {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  date: string;
  author: string;
  readTime: string;
  image: string;
}

export const blogPosts: BlogPost[] = [
  {
    id: 1,
    slug: 'iso-9001-kalite-yonetim-sistemi',
    title: 'ISO 9001 Kalite Yönetim Sistemi Nedir?',
    excerpt: 'ISO 9001 standardı ve işletmenize sağlayacağı avantajlar hakkında detaylı bilgi.',
    content: `ISO 9001, dünya çapında kabul görmüş bir kalite yönetim sistemi standardıdır. İşletmelerin müşteri memnuniyetini artırmak, süreçlerini iyileştirmek ve rekabet avantajı elde etmek için kullandıkları en yaygın standarttır.

## ISO 9001'in Temel Prensipleri

1. **Müşteri Odaklılık**: Müşteri ihtiyaç ve beklentilerinin anlaşılması ve karşılanması
2. **Liderlik**: Üst yönetimin kalite hedeflerine bağlılığı
3. **Çalışanların Katılımı**: Tüm seviyelerdeki personelin aktif katılımı
4. **Süreç Yaklaşımı**: Faaliyetlerin süreç olarak yönetilmesi
5. **Sürekli İyileştirme**: Performansın sürekli geliştirilmesi

## İşletmelere Sağladığı Faydalar

- Müşteri memnuniyetinde artış
- Operasyonel verimlilikte iyileşme
- Maliyetlerde azalma
- Pazar payında büyüme
- Çalışan motivasyonunda artış

## Sertifikasyon Süreci

ISO 9001 sertifikasyonu almak için işletmelerin belirli adımları takip etmesi gerekir. AXIOM Danışmanlık olarak, bu süreçte size rehberlik ediyor ve başarılı bir sertifikasyon için gerekli tüm desteği sağlıyoruz.`,
    category: 'Kalite Yönetimi',
    date: '15 Ocak 2024',
    author: 'Ahmet Yılmaz',
    readTime: '5 dk',
    image: 'https://public.readdy.ai/ai/img_res/8892ce8a44350a026b47f7c226cc0df7.jpg'
  },
  {
    id: 2,
    slug: 'basarili-ise-alim-surecleri',
    title: 'Başarılı İşe Alım Süreçlerinin 5 Altın Kuralı',
    excerpt: 'Doğru yetenekleri işe almak için uygulamanız gereken stratejiler ve yöntemler.',
    content: `İşe alım süreci, bir şirketin başarısında kritik rol oynar. Doğru kişileri doğru pozisyonlara yerleştirmek, uzun vadeli büyüme ve başarı için temel oluşturur.

## 1. Net İş Tanımları Oluşturun

İş ilanınız, pozisyonun gerekliliklerini ve beklentilerini açık bir şekilde belirtmelidir. Belirsiz tanımlar, uygun olmayan başvurulara yol açar.

## 2. Yapılandırılmış Mülakat Süreci

Her aday için aynı kriterleri kullanarak objektif değerlendirme yapın. Bu, adil bir karşılaştırma yapmanızı sağlar.

## 3. Kültürel Uyum Değerlendirmesi

Teknik beceriler kadar, adayın şirket kültürüne uyumu da önemlidir. Uzun vadeli başarı için bu uyum kritiktir.

## 4. Referans Kontrolü

Önceki işverenlerden alınan referanslar, adayın gerçek performansı hakkında değerli bilgiler sağlar.

## 5. Hızlı Karar Verme

Yetenekli adaylar genellikle birden fazla teklif alır. Sürecinizi hızlandırarak en iyi adayları kaçırmayın.

## AXIOM'un İK Danışmanlık Hizmetleri

Profesyonel İK danışmanlığımızla, işe alım süreçlerinizi optimize ediyor ve size en uygun yetenekleri bulmanızda yardımcı oluyoruz.`,
    category: 'İnsan Kaynakları',
    date: '10 Ocak 2024',
    author: 'Ayşe Demir',
    readTime: '6 dk',
    image: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20office%20interview%20scene%20professional%20business%20meeting%20clean%20workspace%20simple%20background%20human%20resources%20recruitment%20atmosphere%20natural%20lighting&width=1200&height=600&seq=blogdetail2&orientation=landscape'
  },
  {
    id: 3,
    slug: 'kurumsal-egitimlerin-onemi',
    title: 'Kurumsal Eğitimlerin İşletmelere Katkısı',
    excerpt: 'Çalışan gelişimi ve kurumsal eğitim programlarının işletme performansına etkileri.',
    content: `Kurumsal eğitimler, modern işletmelerin rekabet avantajı elde etmesinde en önemli araçlardan biridir. Çalışanların sürekli gelişimi, şirketin başarısı için kritik öneme sahiptir.

## Kurumsal Eğitimin Faydaları

### 1. Çalışan Performansında Artış
Düzenli eğitimler, çalışanların becerilerini geliştirerek iş performansını doğrudan artırır.

### 2. Motivasyon ve Bağlılık
Eğitime yatırım yapan şirketler, çalışan bağlılığını ve motivasyonunu artırır.

### 3. Yenilikçilik ve Adaptasyon
Sürekli öğrenen ekipler, değişen pazar koşullarına daha hızlı adapte olur.

### 4. Hata Oranında Azalma
İyi eğitilmiş çalışanlar, daha az hata yapar ve kalite standartlarını korur.

## Etkili Eğitim Programı Nasıl Oluşturulur?

1. **İhtiyaç Analizi**: Eğitim ihtiyaçlarını belirleyin
2. **Hedef Belirleme**: Net ve ölçülebilir hedefler koyun
3. **İçerik Geliştirme**: Pratik ve uygulanabilir içerik hazırlayın
4. **Uygulama**: Etkileşimli ve katılımcı yöntemler kullanın
5. **Değerlendirme**: Eğitimin etkisini ölçün ve iyileştirin

## AXIOM Eğitim Programları

AXIOM Danışmanlık olarak, sektörünüze özel kurumsal eğitim programları tasarlıyor ve uyguluyoruz. Deneyimli eğitmenlerimiz ve kanıtlanmış metodolojimizle, ekibinizin potansiyelini maksimize ediyoruz.`,
    category: 'Eğitim',
    date: '5 Ocak 2024',
    author: 'Mehmet Kaya',
    readTime: '7 dk',
    image: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20training%20room%20professional%20business%20education%20setting%20clean%20workspace%20simple%20background%20corporate%20learning%20atmosphere%20bright%20lighting&width=1200&height=600&seq=blogdetail3&orientation=landscape'
  },
  {
    id: 4,
    slug: 'kalite-kontrol-dijital-donusum',
    title: 'Kalite Kontrol Süreçlerinde Dijital Dönüşüm',
    excerpt: 'Endüstri 4.0 ile birlikte kalite kontrol süreçlerinin dijitalleşmesi ve avantajları.',
    content: `Dijital dönüşüm, kalite kontrol süreçlerini kökten değiştiriyor. Geleneksel yöntemlerden akıllı, veri odaklı sistemlere geçiş, işletmelere önemli avantajlar sağlıyor.

## Dijital Kalite Kontrol Nedir?

Dijital kalite kontrol, sensörler, yapay zeka, makine öğrenimi ve IoT teknolojilerini kullanarak kalite süreçlerini otomatikleştirme ve optimize etme yaklaşımıdır.

## Temel Teknolojiler

### 1. IoT Sensörleri
Gerçek zamanlı veri toplama ve izleme imkanı sağlar.

### 2. Yapay Zeka ve Makine Öğrenimi
Hata tespiti ve tahmine dayalı bakım için kullanılır.

### 3. Bulut Tabanlı Sistemler
Verilerin merkezi yönetimi ve erişilebilirliği sağlar.

### 4. Mobil Uygulamalar
Sahada anlık kalite kontrol ve raporlama imkanı sunar.

## Dijitalleşmenin Faydaları

- **Hata Oranında %40-60 Azalma**: Otomatik tespit sistemleri insan hatasını minimize eder
- **Maliyet Tasarrufu**: Erken tespit sayesinde fire ve yeniden işleme maliyetleri düşer
- **Hız Artışı**: Otomatik süreçler kontrol sürelerini kısaltır
- **Veri Odaklı Kararlar**: Detaylı analizlerle sürekli iyileştirme sağlanır
- **Şeffaflık**: Tüm süreçler izlenebilir ve raporlanabilir

## Dijital Dönüşüm Yol Haritası

1. **Mevcut Durum Analizi**: Süreçlerinizi değerlendirin
2. **Teknoloji Seçimi**: İhtiyaçlarınıza uygun çözümleri belirleyin
3. **Pilot Uygulama**: Küçük ölçekli testlerle başlayın
4. **Eğitim**: Ekibinizi yeni sistemlere hazırlayın
5. **Yaygınlaştırma**: Başarılı uygulamaları genişletin
6. **Sürekli İyileştirme**: Verileri analiz edin ve optimize edin

## AXIOM'un Dijital Kalite Çözümleri

AXIOM Danışmanlık olarak, kalite kontrol süreçlerinizin dijital dönüşümünde yanınızdayız. Modern teknolojileri işletmenize entegre ediyor ve rekabet avantajı elde etmenizi sağlıyoruz.`,
    category: 'Teknoloji',
    date: '1 Ocak 2024',
    author: 'Zeynep Arslan',
    readTime: '8 dk',
    image: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20digital%20quality%20control%20dashboard%20tablet%20screen%20showing%20analytics%20charts%20clean%20workspace%20industrial%20technology%20simple%20background%20professional%20lighting&width=1200&height=600&seq=blogdetail4&orientation=landscape'
  },
  {
    id: 5,
    slug: 'six-sigma-metodolojisi',
    title: 'Six Sigma Metodolojisi: Mükemmelliğe Giden Yol',
    excerpt: 'Six Sigma nedir, nasıl uygulanır ve işletmenize nasıl değer katar? Detaylı rehber.',
    content: `Six Sigma, süreç iyileştirme ve kalite yönetiminde dünya çapında kabul görmüş bir metodoloji ve disiplindir. Motorola tarafından 1980'lerde geliştirilen bu yaklaşım, hataları minimize ederek mükemmelliğe ulaşmayı hedefler.

## Six Sigma Nedir?

Six Sigma, istatistiksel yöntemler kullanarak süreçlerdeki değişkenliği azaltmayı ve hata oranını milyonda 3.4'e düşürmeyi amaçlayan bir kalite yönetim metodolojisidir. Bu, %99.99966 doğruluk oranı anlamına gelir.

## DMAIC Metodolojisi

Six Sigma'nın temel yaklaşımı DMAIC olarak bilinen 5 aşamalı süreçtir:

### 1. Define (Tanımlama)
- Problem ve hedeflerin net tanımlanması
- Müşteri gereksinimlerinin belirlenmesi
- Proje kapsamının oluşturulması
- Süreç haritalarının çıkarılması

### 2. Measure (Ölçme)
- Mevcut performansın ölçülmesi
- Veri toplama sistemlerinin kurulması
- Temel metriklerin belirlenmesi
- Süreç kapasitesinin değerlendirilmesi

### 3. Analyze (Analiz)
- Kök neden analizinin yapılması
- Veri analizi ve istatistiksel değerlendirme
- Değişkenlik kaynaklarının belirlenmesi
- Hipotez testlerinin uygulanması

### 4. Improve (İyileştirme)
- Çözüm alternatiflerinin geliştirilmesi
- Pilot uygulamaların yapılması
- Süreç optimizasyonu
- Yeni süreçlerin test edilmesi

### 5. Control (Kontrol)
- İyileştirmelerin standartlaştırılması
- Kontrol planlarının oluşturulması
- Sürekli izleme sistemlerinin kurulması
- Dokümantasyon ve eğitim

## Six Sigma Kemer Sistemi

Six Sigma'da yetkinlik seviyeleri kemer renkleriyle ifade edilir:

- **White Belt**: Temel farkındalık seviyesi
- **Yellow Belt**: Proje ekip üyesi seviyesi
- **Green Belt**: Proje lideri seviyesi
- **Black Belt**: Tam zamanlı uzman seviyesi
- **Master Black Belt**: Mentor ve koç seviyesi

## İşletmelere Sağladığı Faydalar

### Finansal Kazançlar
- Maliyetlerde %20-50 azalma
- Verimlilik artışı
- Fire ve hata maliyetlerinde düşüş
- Yatırım getirisinde artış

### Operasyonel İyileştirmeler
- Süreç verimliliğinde artış
- Çevrim sürelerinde kısalma
- Kapasite kullanımında iyileşme
- Kalite seviyesinde yükselme

### Stratejik Avantajlar
- Müşteri memnuniyetinde artış
- Pazar payında büyüme
- Rekabet avantajı
- Marka değerinde artış

## Başarılı Uygulama İçin Kritik Faktörler

1. **Üst Yönetim Desteği**: Liderlik ve kaynak tahsisi
2. **Doğru Proje Seçimi**: Stratejik öneme sahip projeler
3. **Eğitim ve Gelişim**: Ekiplerin yetkinleştirilmesi
4. **Veri Odaklı Yaklaşım**: Objektif karar alma
5. **Kültür Değişimi**: Sürekli iyileştirme zihniyeti

## Sektörel Uygulamalar

Six Sigma farklı sektörlerde başarıyla uygulanmaktadır:

- **İmalat**: Üretim süreçlerinde hata azaltma
- **Hizmet**: Müşteri hizmetleri iyileştirme
- **Sağlık**: Hasta güvenliği ve süreç optimizasyonu
- **Finans**: İşlem hataları ve süre azaltma
- **Lojistik**: Teslimat performansı iyileştirme

## AXIOM Six Sigma Danışmanlığı

AXIOM olarak, Six Sigma metodolojisinin işletmenizde başarılı bir şekilde uygulanması için:

- Kapsamlı eğitim programları
- Proje koçluğu ve mentorluk
- Sertifikasyon desteği
- Uygulama danışmanlığı
- Sürekli iyileştirme kültürü oluşturma

sunuyoruz. Deneyimli Black Belt ve Master Black Belt uzmanlarımızla yanınızdayız.`,
    category: 'Kalite Yönetimi',
    date: '20 Ocak 2024',
    author: 'Dr. Mehmet Öztürk',
    readTime: '10 dk',
    image: 'https://readdy.ai/api/search-image?query=professional%20business%20analytics%20six%20sigma%20quality%20management%20charts%20graphs%20data%20analysis%20modern%20office%20workspace%20clean%20minimalist%20background%20statistical%20process%20control%20industrial%20excellence&width=1200&height=600&seq=blogdetail5&orientation=landscape'
  },
  {
    id: 6,
    slug: 'toyota-uretim-sistemi',
    title: 'Toyota Üretim Sistemi ve Lean Manufacturing',
    excerpt: 'Toyota\'nın dünyayı değiştiren üretim felsefesi ve Lean Manufacturing prensipleri.',
    content: `Toyota Üretim Sistemi (TPS), modern üretim yönetiminin temel taşlarından biridir. 1950'lerde Taiichi Ohno ve Eiji Toyoda tarafından geliştirilen bu sistem, Lean Manufacturing'in temelini oluşturmuştur.

## Toyota Üretim Sisteminin Temelleri

TPS, iki temel prensip üzerine inşa edilmiştir:

### 1. Jidoka (Otonomasyon)
İnsan dokunuşlu otomasyon anlamına gelir. Makineler bir problem tespit ettiğinde otomatik olarak durur ve hatalı ürün üretimini engeller.

**Jidoka'nın Faydaları:**
- Hataların kaynakta yakalanması
- Kalite sorunlarının yayılmasının önlenmesi
- İnsan-makine işbirliğinin optimize edilmesi
- Sürekli iyileştirme kültürünün gelişmesi

### 2. Just-In-Time (Tam Zamanında Üretim)
Sadece ihtiyaç duyulduğunda, ihtiyaç duyulan miktarda, ihtiyaç duyulan zamanda üretim yapmak.

**JIT'in Avantajları:**
- Stok maliyetlerinde azalma
- Nakit akışında iyileşme
- Alan kullanımında verimlilik
- Fire ve israfın minimize edilmesi

## 7 Tür İsraf (Muda)

Toyota, üretimde 7 tür israf tanımlamıştır:

### 1. Aşırı Üretim
İhtiyaçtan fazla veya erken üretim yapılması. En tehlikeli israf türüdür çünkü diğer israfları gizler.

### 2. Bekleme
İşçilerin veya makinelerin atıl kalması, malzeme veya bilgi beklemesi.

### 3. Taşıma
Gereksiz malzeme veya ürün hareketi. Değer katmayan her hareket israftır.

### 4. Aşırı İşleme
Müşterinin talep etmediği özellikler veya gereksiz işlem adımları.

### 5. Stok
İhtiyaçtan fazla hammadde, yarı mamul veya mamul stoku.

### 6. Hareket
Operatörlerin gereksiz hareketleri, ergonomik olmayan çalışma koşulları.

### 7. Hatalı Üretim
Kalite hataları, yeniden işleme, hurda ve fire.

## 5S Metodolojisi

Toyota'nın temel araçlarından biri olan 5S, çalışma alanı organizasyonunu sağlar:

### Seiri (Ayıklama)
Gereksiz eşyaların ayıklanması ve uzaklaştırılması.

### Seiton (Düzenleme)
Her şeyin belirli bir yeri olması ve kolay erişilebilir olması.

### Seiso (Temizlik)
Çalışma alanının temiz ve düzenli tutulması.

### Seiketsu (Standartlaştırma)
İlk üç S'nin standart haline getirilmesi.

### Shitsuke (Disiplin)
Standartlara uyumun sürdürülmesi ve sürekli iyileştirme.

## Kaizen: Sürekli İyileştirme

Kaizen, Toyota kültürünün kalbinde yer alır. Küçük, sürekli iyileştirmeler yaparak büyük sonuçlar elde etme felsefesidir.

**Kaizen Prensipleri:**
- Herkes katılır (yöneticiden operatöre)
- Küçük adımlarla ilerleme
- Günlük iyileştirmeler
- Standartlaştırma ve sürdürülebilirlik
- Sorunları fırsat olarak görme

## Andon Sistemi

Andon, üretim hattında sorunları görselleştiren ve hızlı müdahale sağlayan bir sistemdir.

**Andon'un Özellikleri:**
- Görsel yönetim
- Hızlı problem bildirimi
- Ekip çalışması
- Sürekli iyileştirme döngüsü

## Poka-Yoke (Hata Önleme)

Hataların oluşmasını engelleyen veya hataları hemen tespit eden mekanizmalar.

**Poka-Yoke Örnekleri:**
- USB girişlerinin tek yönlü olması
- Otomobillerde emniyet kemeri uyarısı
- Üretimde şablon ve fikstürler
- Sensör ve kontrol sistemleri

## Heijunka (Üretim Dengeleme)

Üretim programının dengelenmesi ve düzleştirilmesi. Talep dalgalanmalarının etkisini azaltır.

**Heijunka Faydaları:**
- Kapasite kullanımında denge
- Stok seviyelerinde istikrar
- İş yükünde düzenlilik
- Esneklik ve hızlı tepki

## Gemba: Gerçek Yerin Önemi

Gemba, işin gerçekten yapıldığı yer anlamına gelir. Toyota yöneticileri, kararları gemba'da gözlem yaparak alır.

**Gemba Yürüyüşü:**
- Düzenli saha ziyaretleri
- Çalışanlarla doğrudan iletişim
- Sorunların yerinde görülmesi
- Gerçek verilere dayalı karar alma

## Toyota Yolu'nun İş Dünyasına Etkisi

TPS, sadece otomotiv sektöründe değil, tüm sektörlerde devrim yaratmıştır:

- **Sağlık**: Hastane süreçlerinde Lean uygulamaları
- **Yazılım**: Agile ve DevOps metodolojileri
- **Hizmet**: Süreç optimizasyonu ve müşteri deneyimi
- **İnşaat**: Lean Construction prensipleri
- **Lojistik**: Tedarik zinciri optimizasyonu

## Başarılı Uygulama İçin Öneriler

1. **Kültür Değişimi**: Üst yönetimden başlayarak tüm organizasyonda
2. **Eğitim ve Gelişim**: Sürekli öğrenme ve gelişim
3. **Sabır ve Kararlılık**: Sonuçlar zaman alır
4. **Standartlaştırma**: İyileştirmelerin kalıcı hale getirilmesi
5. **Müşteri Odaklılık**: Her şeyin merkezinde müşteri değeri

## AXIOM Lean Danışmanlığı

AXIOM olarak, Toyota Üretim Sistemi ve Lean Manufacturing prensiplerinin işletmenizde uygulanması için:

- Mevcut durum analizi ve değer akışı haritalama
- Lean eğitim programları
- Kaizen etkinlikleri ve workshop'lar
- 5S uygulamaları
- Sürekli iyileştirme kültürü oluşturma
- Performans ölçüm sistemleri

konularında kapsamlı danışmanlık hizmeti sunuyoruz. Deneyimli uzmanlarımızla, operasyonel mükemmelliğe ulaşmanızda yanınızdayız.`,
    category: 'Üretim Yönetimi',
    date: '18 Ocak 2024',
    author: 'Mühendis Kemal Aydın',
    readTime: '12 dk',
    image: 'https://readdy.ai/api/search-image?query=modern%20automotive%20manufacturing%20assembly%20line%20toyota%20production%20system%20lean%20manufacturing%20clean%20organized%20factory%20floor%20industrial%20efficiency%20quality%20control%20minimalist%20professional%20lighting&width=1200&height=600&seq=blogdetail6&orientation=landscape'
  },
  {
    id: 7,
    slug: 'toplam-kalite-yonetimi',
    title: 'Toplam Kalite Yönetimi (TKY) Nedir?',
    excerpt: 'TKY felsefesi, prensipleri ve işletmelerde başarılı uygulama stratejileri.',
    content: `Toplam Kalite Yönetimi (TKY), organizasyonun tüm süreçlerinde kaliteyi merkeze alan, müşteri odaklı ve sürekli iyileştirmeyi hedefleyen kapsamlı bir yönetim felsefesidir.

## TKY'nin Temel Prensipleri

### 1. Müşteri Odaklılık
Müşteri memnuniyeti ve beklentilerinin karşılanması her şeyin merkezindedir.

### 2. Sürekli İyileştirme
Kaizen felsefesiyle süreçlerin sürekli geliştirilmesi.

### 3. Herkesin Katılımı
Üst yönetimden operatöre kadar tüm çalışanların aktif katılımı.

### 4. Süreç Yaklaşımı
Sonuçlar yerine süreçlere odaklanma.

### 5. Sistematik Yaklaşım
Birbiriyle ilişkili süreçlerin bir sistem olarak yönetilmesi.

## TKY Uygulamasının Faydaları

- Müşteri memnuniyetinde artış
- Maliyetlerde azalma
- Verimlilik artışı
- Çalışan motivasyonunda yükselme
- Rekabet gücünde artış

## AXIOM TKY Danışmanlığı

TKY sistemlerinin kurulması ve geliştirilmesinde profesyonel destek sağlıyoruz.`,
    category: 'Kalite Yönetimi',
    date: '12 Ocak 2024',
    author: 'Prof. Dr. Ayşe Kılıç',
    readTime: '8 dk',
    image: 'https://readdy.ai/api/search-image?query=total%20quality%20management%20business%20excellence%20teamwork%20collaboration%20modern%20office%20professional%20meeting%20quality%20standards%20continuous%20improvement%20minimalist%20clean%20background&width=1200&height=600&seq=blogdetail7&orientation=landscape'
  },
  {
    id: 8,
    slug: 'performans-yonetimi-sistemleri',
    title: 'Etkili Performans Yönetimi Sistemleri',
    excerpt: 'Çalışan performansını artıran modern performans yönetimi yaklaşımları ve uygulamaları.',
    content: `Performans yönetimi, organizasyonların hedeflerine ulaşması için çalışan performansının planlanması, izlenmesi, değerlendirilmesi ve geliştirilmesi sürecidir.

## Modern Performans Yönetimi

Geleneksel yıllık değerlendirmelerden, sürekli geri bildirim ve gelişim odaklı sistemlere geçiş.

### Temel Bileşenler

1. **Hedef Belirleme**: SMART hedefler ve OKR metodolojisi
2. **Sürekli Geri Bildirim**: Düzenli 1-1 görüşmeler
3. **Gelişim Planları**: Kişiselleştirilmiş kariyer yolları
4. **Tanıma ve Ödüllendirme**: Başarıların takdir edilmesi

## Performans Değerlendirme Yöntemleri

- 360 Derece Geri Bildirim
- KPI Bazlı Değerlendirme
- Yetkinlik Bazlı Değerlendirme
- Proje Bazlı Değerlendirme

## AXIOM Performans Yönetimi Danışmanlığı

Modern performans yönetimi sistemlerinin kurulması ve optimizasyonunda yanınızdayız.`,
    category: 'İnsan Kaynakları',
    date: '8 Ocak 2024',
    author: 'Elif Yıldırım',
    readTime: '7 dk',
    image: 'https://readdy.ai/api/search-image?query=performance%20management%20business%20analytics%20dashboard%20charts%20graphs%20employee%20evaluation%20modern%20office%20workspace%20professional%20clean%20minimalist%20background%20HR%20technology&width=1200&height=600&seq=blogdetail8&orientation=landscape'
  }
];
